import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import InspecaoQualidade from "model/qualidade/InspecaoQualidade";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import InspecaoQualidadeService from "service/qualidade/InspecaoQualidadeService";
import "react-hook-form"
import { Controller, useForm } from "react-hook-form";
import { Label } from "components/input/Label";

const inspecaoQualidadeService = new InspecaoQualidadeService();

export default function InspecaoQualidadeCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, setFocus, register, clearErrors, setError, formState: {errors} } = useForm();

    const inputDescricaoRef = useRef<any>(null);

    const [inspecaoQualidade, setInspecaoQualidade] = useState<InspecaoQualidade>(new InspecaoQualidade());
    const [titulo, setTitulo] = useState<string>('Inspeção');

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();


    function validar() {

        if(!inspecaoQualidade.codigoInterno) {
            setError("codigoInterno", {type: "manual", message: "Código é Obrigatório"}, {shouldFocus: true})
            return false
        }

        if (!inspecaoQualidade.descricao) {
            setError("descricao", {type: "manual", message: "Descrição é Obrigatória"}, {shouldFocus: true})
            return false;
        }

        if(!inspecaoQualidade.tipoResultado) {
            setError("tipoResultado", {type: "manual", message: "Tipo Resultado é Obrigatório"}, {shouldFocus: true})
            return false
        }
        return true;
    }

    function validarPersonalizado() {
        if(inspecaoQualidade.valorMinimo>inspecaoQualidade.valorMaximo && inspecaoQualidade.valorMaximo != null){
            msgAlerta(`Valores inválidos`, "O valor mínimo não pode ser maior que o valor máximo");
            return false;
        }
        return true;
    }

    const codigoKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            if (!inspecaoQualidade.codigoInterno) {
                inspecaoQualidadeService.proximoCodigo().then((data) => {
                    setInspecaoQualidade({...inspecaoQualidade, codigoInterno: data});
                    setFocus("descricao");
                    clearErrors("codigoInterno");
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    return (

        <BaseCadastro model={inspecaoQualidade} service={inspecaoQualidadeService} setModel={(value: InspecaoQualidade) => setInspecaoQualidade(value)} 
            validar={() => validar()} validarPersonalizado={() => validarPersonalizado()} 
            urlService="/inspecaoQualidade" pathCadastro="/inspecaoQualidade" tituloPagina={'InspecaoQualidade'}
        >

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText 
                        className={errors.codigoInterno ? "p-invalid" : ""}
                        required value={inspecaoQualidade.codigoInterno} 
                        onKeyDown={codigoKeyDown} 
                         
                        style={{ width: '30%' }} 
                        {...register("codigoInterno",{
                            onChange: (e) => {
                                clearErrors("codigoInterno")
                                setInspecaoQualidade({ ...inspecaoQualidade, codigoInterno: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.codigoInterno && errors.codigoInterno.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigoInterno?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Descrição</Label>
                <div className="col-sm-12">
                    <InputText 
                    className={errors.descricao ? "p-invalid" : ""}
                    required value={inspecaoQualidade.descricao} 
                    style={{ width: '30%' }} 
                    {...register("descricao",{
                        onChange: (e) => {
                            clearErrors("descricao")
                            setInspecaoQualidade({ ...inspecaoQualidade, descricao: e.target.value })
                        }
                    })}
                    />
                </div>
                {errors.descricao && errors.descricao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.descricao?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Valor Alvo</Label>
                <div className="col-sm-12">
                    <InputNumber
                        value={inspecaoQualidade.valorAlvo}
                        maxFractionDigits={6}
                        max={9999999999}
                        onChange={(e) => setInspecaoQualidade({ ...inspecaoQualidade, valorAlvo: e.value as number })}
                        style={{ width: '30%' }}
                        locale="pt-BR" />
                </div>
            </div>


            <div className="row">
                <Label className="col col-sm-12">Valor Mínimo</Label>
                <div className="col-sm-12">
                    <InputNumber
                        value={inspecaoQualidade.valorMinimo}
                        maxFractionDigits={6}
                        max={9999999999}
                        onChange={(e) => setInspecaoQualidade({ ...inspecaoQualidade, valorMinimo: e.value as number })}
                        style={{ width: '30%' }}
                        locale="pt-BR" />
                </div>
            </div>


            <div className="row">
                <Label className="col col-sm-12">Valor Máximo</Label>
                <div className="col-sm-12">
                    <InputNumber
                        value={inspecaoQualidade.valorMaximo}
                        maxFractionDigits={6}
                        max={9999999999}
                        onChange={(e) => setInspecaoQualidade({ ...inspecaoQualidade, valorMaximo: e.value as number })}
                        style={{ width: '30%' }}
                        locale="pt-BR" />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Tipo Resultado</Label>
                <div className="col-sm-12">
                    <Controller name="tipoResultado" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            options={inspecaoQualidadeService.getTiposResultado()}
                            className={errors.tipoResultado ? "p-invalid" : ""}
                            optionLabel="label"
                            optionValue="value"
                            value={inspecaoQualidade.tipoResultado}
                            style={{ width: '30%' }}
                            onChange= {(e) => {
                                clearErrors("tipoResultado")
                                setInspecaoQualidade({ ...inspecaoQualidade, tipoResultado: e.target.value})
                            }}
                        />
                    )}/>
                </div>
                {errors.tipoResultado && errors.tipoResultado.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.tipoResultado?.message as string}</span> : null}
            </div>

        </BaseCadastro>
    )
}
